import { render, staticRenderFns } from "./CoolingLoadExplanation.vue?vue&type=template&id=0c413ac6&scoped=true&"
import script from "./CoolingLoadExplanation.vue?vue&type=script&lang=js&"
export * from "./CoolingLoadExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c413ac6",
  null
  
)

export default component.exports